// frontend/src/hooks/useCRSConditionals.js
import { useMemo } from 'react';
import { BAD_VALUE } from '../constants/crsFormOptions'; // Adjust path as needed

function useCRSConditionals(formData) {
  const isMarriedOrCommonLaw = useMemo(() => formData.maritalStatus === 'B' || formData.maritalStatus === 'E', [formData.maritalStatus]);

  const showSpouseIsPRQuestion = useMemo(() => isMarriedOrCommonLaw, [isMarriedOrCommonLaw]);

  const showSpouseAccompanyQuestion = useMemo(() => isMarriedOrCommonLaw && formData.spouseOrPartnerIsPR === 'A', [isMarriedOrCommonLaw, formData.spouseOrPartnerIsPR]);

  const showSpouseFactors = useMemo(() => isMarriedOrCommonLaw && formData.spouseOrPartnerIsPR === 'A' && formData.spouseOrPartnerWillAccompany === 'B', [isMarriedOrCommonLaw, formData.spouseOrPartnerIsPR, formData.spouseOrPartnerWillAccompany]);

  const showCanadianEducationLevel = useMemo(() => formData.studiedInCanada === 'B', [formData.studiedInCanada]);

  const showJobOfferNoc = useMemo(() => formData.hasValidJobOffer === 'B', [formData.hasValidJobOffer]);

  // Note: The original logic for showSecondLanguageScores was based on hasSecondLanguageTest === 'A'.
  // However, hasSecondLanguageTest is now derived *within* the handleChange logic based on secondLanguageTest selection.
  // The visibility of the second language score inputs should depend directly on whether a valid second test (not BAD_VALUE and not 'C' for N/A) is selected.
  const showSecondLanguageScores = useMemo(() => formData.secondLanguageTest !== BAD_VALUE && formData.secondLanguageTest !== 'NA', [formData.secondLanguageTest]);

  // Similarly, spouse language scores visibility depends on spouse test selection.
  const showSpouseLanguageScores = useMemo(() => showSpouseFactors && formData.spouseLanguageTest !== BAD_VALUE && formData.spouseLanguageTest !== 'E', [showSpouseFactors, formData.spouseLanguageTest]); // 'E' was 'Not applicable'

  return {
    isMarriedOrCommonLaw,
    showSpouseIsPRQuestion,
    showSpouseAccompanyQuestion,
    showSpouseFactors,
    showCanadianEducationLevel,
    showJobOfferNoc,
    showSecondLanguageScores, // This might need adjustment based on how hasSecondLanguageTest is handled now
    showSpouseLanguageScores,
  };
}

export default useCRSConditionals;